<div *ngIf="!isDisabled" class="flex justify-center flex-1 px-2 pb-2 space-x-6">
  <button
    mat-button
    type="button"
    style="min-width: 60%"
    class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
    (click)="createNewSection()"
    mat-raised-button
    data-testid="addSectionButton"
  >
    Add Section
  </button>
</div>
<div cdkDropList (cdkDropListDropped)="drop($event)">
  <app-digital-publication-section
    *ngFor="let section of sectionArray.controls; let index = index"
    cdkDrag
    (cdkDragStarted)="dragStarted()"
    class="py-2"
    [index]="index"
    [section]="section.value"
    [urlPath]="urlPath.value"
    [sectionErrors]="section.errors"
    [changingSectionOrder$]="changingSectionOrder$"
    [isDisabled]="isDisabled"
    (sectionOrderChanged)="sectionOrderChanged($event)"
    (removeSectionClick)="removeSectionClick($event)"
    (sectionChanged)="sectionChanged($event)"
  ></app-digital-publication-section>
</div>
<div
  *ngIf="!isDisabled && sectionArray.length > 0"
  class="flex justify-center flex-1 px-2 py-2 space-x-6"
>
  <button
    mat-button
    type="button"
    style="min-width: 60%"
    class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
    (click)="createNewSection()"
    mat-raised-button
    data-testid="addSectionButton2"
  >
    Add Section
  </button>
</div>
